import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import Hint from './Hint';
import Input from './Input';
import withClassNames from '../behaviors/classNames';
export default withClassNames(function (_ref) {
  var inputRef = _ref.inputRef,
      referenceElementRef = _ref.referenceElementRef,
      shouldSelectHint = _ref.shouldSelectHint,
      props = _objectWithoutPropertiesLoose(_ref, ["inputRef", "referenceElementRef", "shouldSelectHint"]);

  return /*#__PURE__*/React.createElement(Hint, {
    shouldSelect: shouldSelectHint
  }, /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    ref: function ref(node) {
      inputRef(node);
      referenceElementRef(node);
    }
  })));
});